import React from "react"
import { Link } from "react-router-dom"

const Footer = () => {
  return (
    <footer>
      <p className="links">
        <Link to="/" className="li">
          Home
        </Link>
        <Link to="/About-us" className="li">
          About Us
        </Link>
        <Link to="/Terms" className="li">
          Terms
        </Link>
      </p>
      <p className="copyright">
        Copyright &copy; 2020
        <a>TeddaaGram</a>. All rights reserved.
      </p>
    </footer>
  )
}

export default Footer
